import type { CSSProp } from 'styled-components';
import { css } from 'styled-components';

export const lineClamp = (value = 1): CSSProp => css`
  display: -webkit-box;
  -webkit-line-clamp: ${value};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
